import CheckboxField from "./fields/CheckboxField"
import SelectField from "./fields/SelectField"
import TextAreaField from "./fields/TextAreaField"
import TextField from "./fields/TextField"
import Recaptcha from "./fields/Recaptcha"

export enum SectionTypes {
  Column = "COLUMN",
  Row = "ROW",
}

export enum FieldTypes {
  Checkbox = "CHECKBOX",
  Select = "SELECT",
  Recaptcha = "RECAPTCHA",
  Text = "TEXT",
  TextArea = "TEXTAREA",
}

export const FieldTypesComponentMap = {
  [FieldTypes.Checkbox]: CheckboxField,
  [FieldTypes.Select]: SelectField,
  [FieldTypes.Text]: TextField,
  [FieldTypes.TextArea]: TextAreaField,
  [FieldTypes.Recaptcha]: Recaptcha,
}

export interface FieldProps {
  type: FieldTypes
  name: string
  label: string
  placeholder?: string
  options?: Array<{
    label: string
    value: string | number
    disabled?: boolean
  }>
  isChecked?: boolean
  className?: string
  disabled?: boolean
}
